document.addEventListener('DOMContentLoaded', function () {
  var pdp = document.querySelector('.tbx-pdp');
  if (!pdp) return;

  var main = pdp.querySelector('[data-pdp-main]');
  pdp.querySelectorAll('[data-pdp-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-full');
      if (main && src) {
        main.src = src;
        pdp.querySelectorAll('[data-pdp-thumb]').forEach(function (el) {
          el.classList.toggle('is-active', el === btn);
        });
      }
    });
  });

  pdp.querySelectorAll('[data-pdp-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var id = tab.getAttribute('data-pdp-tab');
      pdp.querySelectorAll('[data-pdp-tab]').forEach(function (el) {
        el.classList.toggle('is-active', el === tab);
      });
      pdp.querySelectorAll('[data-pdp-panel]').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-pdp-panel') === id);
      });
    });
  });

  var jsonEl = pdp.querySelector('[data-pdp-variants]');
  if (!jsonEl) return;

  var variants = [];
  try {
    variants = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }
  if (!variants.length) return;

  var optionButtons = Array.from(pdp.querySelectorAll('[data-pdp-option]'));
  var selected = ['', '', ''];
  var activeBtns = pdp.querySelectorAll('[data-pdp-option].is-active');
  activeBtns.forEach(function (btn) {
    selected[Number(btn.getAttribute('data-option-index'))] = btn.getAttribute('data-value');
  });

  function money(cents) {
    if (window.tbxQar) return window.tbxQar(cents);
    var n = Math.round(Number(cents) || 0) / 100;
    var parts = n.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'QAR ' + parts.join('.');
  }

  function warrantyExtra() {
    var total = 0;
    var checked = pdp.querySelector('[data-pdp-warranty]:checked');
    if (checked) total += Number(checked.getAttribute('data-extra') || 0);
    pdp.querySelectorAll('.tbx-pdp__delivery-choice input:checked').forEach(function (input) {
      total += Number(input.getAttribute('data-extra') || 0);
    });
    return total;
  }

  function tickEta() {
    var el = pdp.querySelector('[data-pdp-eta]');
    if (!el) return;
    var checked = pdp.querySelector('.tbx-pdp__delivery-choice input:checked');
    var mode = (checked && checked.getAttribute('data-eta-mode')) || el.getAttribute('data-eta-mode') || 'static';
    var staticText = (checked && checked.getAttribute('data-eta-text')) || '';
    if (mode !== 'countdown') {
      el.textContent = staticText || el.textContent;
      return;
    }
    var now = new Date();
    var cutoff = new Date(now);
    cutoff.setHours(16, 30, 0, 0);
    if (now >= cutoff) cutoff.setDate(cutoff.getDate() + 1);
    var mins = Math.max(1, Math.round((cutoff - now) / 60000));
    var showMins = Math.min(20, mins);
    var sameDay = cutoff.toDateString() === now.toDateString();
    var hours = cutoff.getHours();
    var minutes = String(cutoff.getMinutes()).padStart(2, '0');
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    el.innerHTML = 'Order within <b>' + showMins + ' mins</b> to get it by <b>' + (sameDay ? 'Today' : 'Tomorrow') + ', ' + hours + ':' + minutes + ' ' + ampm + '</b>';
  }
  tickEta();
  setInterval(tickEta, 30000);

  var locEl = pdp.querySelector('[data-pdp-loc]');
  var locCities = pdp.querySelector('[data-pdp-cities]');
  var locChange = pdp.querySelector('[data-pdp-change]');
  try {
    var savedLoc = localStorage.getItem('tbx-deliver-to');
    if (savedLoc && locEl) locEl.textContent = 'Delivery to ' + savedLoc;
  } catch (e) {}
  if (locChange && locCities) {
    locChange.addEventListener('click', function () {
      var open = locCities.hasAttribute('hidden');
      if (open) locCities.removeAttribute('hidden');
      else locCities.setAttribute('hidden', '');
      locChange.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    locCities.querySelectorAll('[data-pdp-city]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var city = btn.getAttribute('data-pdp-city');
        if (locEl && city) locEl.textContent = 'Delivery to ' + city;
        try {
          localStorage.setItem('tbx-deliver-to', city);
        } catch (err) {}
        locCities.setAttribute('hidden', '');
        locChange.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function qtyMax(variant) {
    var input = pdp.querySelector('[data-pdp-qty-input]');
    var fromVariant = variant && Number(variant.qty_max);
    var fromInput = input ? parseInt(input.getAttribute('max'), 10) : 99;
    var max = fromVariant > 0 ? fromVariant : fromInput;
    return max > 0 ? max : 99;
  }

  function qtyValue() {
    var input = pdp.querySelector('[data-pdp-qty-input]');
    var n = input ? parseInt(input.value, 10) : 1;
    if (!(n > 0)) n = 1;
    return n;
  }

  function syncQty() {
    var hidden = pdp.querySelector('[data-pdp-qty]');
    if (hidden) hidden.value = String(qtyValue());
  }

  function findVariant() {
    var exact = variants.find(function (v) {
      return (
        (v.option1 || '') === (selected[0] || v.option1 || '') &&
        (v.option2 || '') === (selected[1] || v.option2 || '') &&
        (v.option3 || '') === (selected[2] || v.option3 || '')
      );
    });
    if (exact) return exact;
    return variants.find(function (v) {
      if (selected[0] && v.option1 !== selected[0]) return false;
      if (selected[1] && v.option2 !== selected[1]) return false;
      if (selected[2] && v.option3 !== selected[2]) return false;
      return true;
    }) || variants.find(function (v) {
      return selected[0] && v.option1 === selected[0];
    }) || variants[0];
  }

  function syncSelectedFromVariant(variant) {
    selected[0] = variant.option1 || '';
    selected[1] = variant.option2 || '';
    selected[2] = variant.option3 || '';
    optionButtons.forEach(function (btn) {
      var index = Number(btn.getAttribute('data-option-index'));
      var value = btn.getAttribute('data-value');
      btn.classList.toggle('is-active', selected[index] === value);
      var probe = selected.slice();
      probe[index] = value;
      var exists = variants.some(function (v) {
        return (
          (!probe[0] || v.option1 === probe[0]) &&
          (!probe[1] || !v.option2 || v.option2 === probe[1]) &&
          (!probe[2] || !v.option3 || v.option3 === probe[2])
        );
      });
      btn.classList.toggle('is-disabled', !exists);
    });
    pdp.querySelectorAll('[data-pdp-option-label]').forEach(function (label, i) {
      var group = label.closest('[data-option-index]');
      var idx = group ? Number(group.getAttribute('data-option-index')) : i;
      if (selected[idx]) label.textContent = selected[idx];
    });
  }

  function render(variant) {
    if (!variant) return;
    syncSelectedFromVariant(variant);

    var qtyInputEl = pdp.querySelector('[data-pdp-qty-input]');
    var maxQty = qtyMax(variant);
    if (qtyInputEl) {
      qtyInputEl.setAttribute('max', String(maxQty));
      if (qtyValue() > maxQty) qtyInputEl.value = String(maxQty);
    }
    var qty = qtyValue();
    var extra = warrantyExtra();
    var unit = Number(variant.price) + extra;
    var line = Number(variant.price) * qty + extra;
    var compare = Number(variant.compare || 0);
    var priceEl = pdp.querySelector('[data-pdp-price]');
    var metaEl = pdp.querySelector('[data-pdp-price-meta]');
    var compareEl = pdp.querySelector('[data-pdp-compare]');
    var saveEl = pdp.querySelector('[data-pdp-save]');
    var idEl = pdp.querySelector('[data-pdp-variant-id]');
    var addBtn = pdp.querySelector('[data-pdp-add]');
    var buyBtn = pdp.querySelector('[data-pdp-buy]');
    syncQty();
    tickEta();

    if (priceEl) {
      priceEl.setAttribute('data-qar-cents', String(unit));
      priceEl.textContent = money(unit);
    }
    pdp.querySelectorAll('[data-pdp-split]').forEach(function (el) {
      el.setAttribute('data-qar-split', String(line));
      el.textContent = '4 x ' + money(line / 4);
    });
    pdp.querySelectorAll('[data-pdp-emi]').forEach(function (el) {
      el.setAttribute('data-qar-emi', String(line));
      el.textContent = money(line / 12);
    });
    pdp.querySelectorAll('[data-pdp-points]').forEach(function (el) {
      el.textContent = String(Math.round(line / 100));
    });

    if (compare > variant.price) {
      var saveAmt = compare - variant.price;
      if (metaEl) metaEl.hidden = false;
      if (compareEl) {
        compareEl.setAttribute('data-qar-cents', String(compare));
        compareEl.textContent = money(compare);
      }
      if (saveEl) saveEl.textContent = 'Save ' + money(saveAmt);
    } else if (metaEl) {
      metaEl.hidden = true;
    }

    if (idEl) {
      idEl.value = variant.id;
      idEl.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (addBtn) {
      addBtn.disabled = !variant.available;
      var addLabel = addBtn.querySelector('[data-pdp-add-label]');
      if (addLabel) addLabel.textContent = variant.available ? 'Add to Cart' : 'Sold out';
    }
    if (buyBtn) {
      buyBtn.href = variant.available ? '/cart/' + variant.id + ':' + qtyValue() + '?checkout' : (pdp.getAttribute('data-product-url') || '#');
    }

    var url = pdp.getAttribute('data-product-url') || window.location.pathname;
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', url + '?variant=' + variant.id);
    }
  }

  optionButtons.forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var index = Number(btn.getAttribute('data-option-index'));
      selected[index] = btn.getAttribute('data-value');
      var match = variants.find(function (v) {
        return (
          (!selected[0] || v.option1 === selected[0]) &&
          (!selected[1] || v.option2 === selected[1]) &&
          (!selected[2] || v.option3 === selected[2])
        );
      });
      if (!match) {
        match = variants.find(function (v) {
          if (index === 0) return v.option1 === selected[0];
          if (index === 1) return v.option2 === selected[1];
          return v.option3 === selected[2];
        });
      }
      render(match);
    });
  });

  pdp.querySelectorAll('[data-pdp-warranty], .tbx-pdp__delivery-choice input').forEach(function (input) {
    input.addEventListener('change', function () {
      var card = input.closest('.tbx-pdp__warranty-card, .tbx-pdp__delivery-choice');
      if (card && input.name) {
        pdp.querySelectorAll('input[name="' + input.name + '"]').forEach(function (radio) {
          var wrap = radio.closest('.tbx-pdp__warranty-card, .tbx-pdp__delivery-choice');
          if (wrap) wrap.classList.toggle('is-active', radio.checked);
        });
      }
      render(findVariant());
    });
  });

  pdp.querySelectorAll('[data-pdp-qty-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = pdp.querySelector('[data-pdp-qty-input]');
      if (!input) return;
      var next = qtyValue() + (btn.getAttribute('data-pdp-qty-btn') === '-' ? -1 : 1);
      input.value = String(Math.max(1, Math.min(qtyMax(findVariant()), next)));
      render(findVariant());
    });
  });
  var qtyInput = pdp.querySelector('[data-pdp-qty-input]');
  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      qtyInput.value = String(qtyValue());
      render(findVariant());
    });
  }

  render(findVariant());
});
